<template>
  <div class="modal-vault">
    <div class="vault-header">
      <div class="header-icon">
        <div class="icon-inner">
          <img src="@/assets/img/rewards/vault.png" alt="vault" />
        </div>
      </div>
      <div class="header-title">
      Rivo  <span>{{ activeWallet?.coinType }}</span> {{ $t('modal.225') }}
      </div>
    </div>

    <div class="vault-stats">
      <div class="stats-balance">
        <div class="balance-title">{{ $t('modal.226') }}</div>
        <div class="balance-inner">
          <img src="@/assets/img/rivocoin.png" alt="coin" />
          <AmountNumber :amount="activeWalletBalance" />
        </div>
      </div>
      <div class="stats-vaulted">
        <div class="vaulted-title">{{ $t('modal.227') }}</div>
        <div class="vaulted-inner">
          <img src="@/assets/img/rivocoin.png" alt="coin" />
          <AmountNumber :amount="activeVaultBalance" />
        </div>
      </div>
    </div>

    <div class="vault-amount">
      <img src="@/assets/img/rivocoin.png" alt="coin" />
      <input v-model="modalAmount" @input="modalValidateInput" type="text" placeholder="Enter transfer amount..." />
    </div>

    <button @click="modalDepositButton()" class="button-deposit" :disabled="socketSendLoading !== null">
      <div class="button-inner">{{ $t('modal.228') }}</div>
    </button>
    <button
  @click="modalWithdrawButton()"
  class="button-withdraw"
  :disabled="socketSendLoading !== null || (activeVaultEntry?.expireAt && new Date(activeVaultEntry.expireAt).getTime() > Date.now())"
>
  <div class="button-inner">{{ $t('modal.229') }}</div>
</button>



    <div class="vault-footer">
      <div v-if="modalCountdownText === null" class="footer-unlocked">
        <div class="unlocked-title">{{ $t('modal.230') }}</div>
        <div class="unlocked-content">
          <select v-model="modalTime">
            <option value="10">{{ $t('modal.231') }} + %0.03</option>
            <option value="30">{{ $t('modal.232') }} + %0.09</option>
            <option value="60">{{ $t('modal.233') }} + %0.18</option>
            <option value="360">{{ $t('modal.234') }} + %1.10</option>
            <option value="720">{{ $t('modal.235') }} + %2.5</option>
            <option value="1440">{{ $t('modal.236') }} + %6</option>
          </select>
          <button @click="modalLockButton()" class="button-lock" :disabled="socketSendLoading !== null">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.23077 8.51212C4.23077 -1.45159 15.3077 -1.55635 15.3077 8.51212M4.23077 8.51212H1V19H19V8.51212H15.3077M4.23077 8.51212H15.3077" stroke-width="2"/>
            </svg>
          </button>
        </div>
      </div>
      <div v-else class="footer-locked">
        <div class="locked-title">
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.33333 6.42542C3.33333 -0.770594 11.3333 -0.846256 11.3333 6.42542M3.33333 6.42542H1V14H14V6.42542H11.3333M3.33333 6.42542H11.3333" stroke-width="2"/>
          </svg>
          {{ $t('modal.237') }}
        </div>
        <div class="locked-time">
          <span>{{ modalCountdownText }}</span> {{ $t('modal.238') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AmountNumber from '@/components/AmountNumber';

export default {
  name: 'ModalVault',
  components: { AmountNumber },
  data() {
    return {
      modalAmount: null,
      modalTime: '10',
      modalCountdownText: null,
      modalCountdownRepeater: null,
      vaultRates: {
        10: 0.0003,
        30: 0.0009,
        60: 0.0018,
        360: 0.011,
        720: 0.025,
        1440: 0.06,
      },
    };
  },
  computed: {
    ...mapGetters(['socketSendLoading', 'generalTimeDiff', 'modalsData', 'authUser']),

    activeWallet() {
      const user = this.authUser.user;
      if (!user?.currency) return null;
      const { coinType, type, chain } = user.currency;
      return user.wallets.find(w => w.coinType === coinType && w.type === type && w.chain === chain) || { balance: 0 };
    },
    activeWalletBalance() {
      return this.activeWallet?.balance || 0;
    },
    activeVaultEntry() {
      const user = this.authUser.user;
      if (!user?.vault?.balances) return null;
      const { coinType, type, chain } = user.currency || {};
      return user.vault.balances.find(v => v.coinType === coinType && v.type === type && v.chain === chain) || null;
    },
    activeVaultBalance() {
      return this.activeVaultEntry?.amount || 0;
    }
  },
  methods: {
    ...mapActions([
      'notificationShow',
      'generalSendVaultDepositSocket',
      'generalSendVaultWithdrawSocket',
      'generalSendVaultLockSocket'
    ]),
    modalValidateInput() {
      this.modalAmount = this.modalAmount.replace(',', '.').replace(/[^\d.]/g, '');
      this.modalAmount = this.modalAmount.indexOf('.') >= 0
        ? this.modalAmount.substr(0, this.modalAmount.indexOf('.')) + '.' + this.modalAmount.substr((this.modalAmount.indexOf('.') + 1), 2).replace('.', '')
        : this.modalAmount;
    },
    modalStartCountdown() {
      if (!this.activeVaultEntry?.expireAt) {
        this.modalCountdownText = null;
        return;
      }
      const timeExpire = new Date(this.activeVaultEntry.expireAt).getTime();
      const timeLeft = (timeExpire - (new Date().getTime() + this.generalTimeDiff)) / 1000;

      let h = Math.floor(timeLeft / 3600);
      let m = Math.floor((timeLeft % 3600) / 60);
      let s = Math.floor(timeLeft % 60);

      m = m < 10 ? '0' + m : m;
      s = s < 10 ? '0' + s : s;

      if (timeLeft <= 0) {
        this.modalCountdownText = null;
      } else {
        this.modalCountdownText = `${h}:${m}:${s}`;
        this.modalCountdownRepeater = requestAnimationFrame(this.modalStartCountdown);
      }
    },
    modalDepositButton() {
      const amount = parseFloat(this.modalAmount);
      if (isNaN(amount) || amount <= 0) {
        this.notificationShow({ type: 'error', message: 'Invalid deposit amount.' });
        return;
      }
      const { coinType, chain, type } = this.authUser.user.currency;
      this.generalSendVaultDepositSocket({ amount: Math.floor(amount), coinType, chain, type });
    },
    modalWithdrawButton() {
      const amount = parseFloat(this.modalAmount);
      if (isNaN(amount) || amount <= 0) {
        this.notificationShow({ type: 'error', message: 'Invalid withdraw amount.' });
        return;
      }
      if (this.activeVaultEntry?.expireAt && this.activeVaultEntry.expireAt > new Date().getTime()) {
        this.notificationShow({ type: 'error', message: 'You cannot withdraw while vault is locked.' });
        return;
      }
      const { coinType, chain, type } = this.authUser.user.currency;
      this.generalSendVaultWithdrawSocket({ amount: Math.floor(amount), coinType, chain, type });
    },
    modalLockButton() {
      const amount = parseFloat(this.activeVaultBalance);
      const rate = this.vaultRates[this.modalTime];
      if (isNaN(amount) || amount <= 0) {
        this.notificationShow({ type: 'error', message: 'No amount available in vault to lock.' });
        return;
      }
      const { coinType, chain, type } = this.authUser.user.currency;
      this.generalSendVaultLockSocket({
        time: Math.floor(1000 * 60 * Number(this.modalTime)),
        rate,
        coinType,
        chain,
        type
      });
    }
  },
  watch: {
    activeVaultEntry: {
      deep: true,
      handler() {
        if (this.activeVaultEntry?.expireAt) {
          this.modalStartCountdown();
        }
      }
    }
  },
  created() {
    if (this.activeVaultEntry?.expireAt) {
      this.modalStartCountdown();
    }
  },
  beforeDestroy() {
    cancelAnimationFrame(this.modalCountdownRepeater);
  }
};
</script>




<style scoped>
.modal-vault {
    width: 600px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 35px 30px 30px 30px;
    border-radius: 15px;
    background: var(--background);
}

/* header */
.modal-vault .vault-header {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.modal-vault .header-icon {
    
    padding: 1px;
}
.modal-vault .icon-inner {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.modal-vault .icon-inner img {
    width: 200px;
    height: 200px;
}
.modal-vault .header-title {
    margin-top: 12px;
    text-align: center;
    font-size: 32px;
    font-weight: 900;
    color: #ffffff;
}
.modal-vault .header-title span {
    color: #ffce00;
}

/* vault stats */
.modal-vault .vault-stats {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    margin-top: 20px;
}
.modal-vault .vault-stats:before,
.modal-vault .vault-stats:after {
    content: '';
    width: calc(50% - 180px);
    height: 1px;
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
}
.modal-vault .vault-stats:before {
    left: 0;
    background: linear-gradient(270deg, #c68701 0%, rgba(217, 217, 217, 0) 100%);
}
.modal-vault .vault-stats:after {
    right: 0;
    background: linear-gradient(90deg, #c68701 0%, rgba(217, 217, 217, 0) 100%);
}
.modal-vault .stats-balance,
.modal-vault .stats-vaulted {
    width: 160px;
    height: 50px;
    position: relative;
    padding: 1px;
}
.modal-vault .stats-balance {
    margin-right: 12px;
}
.modal-vault .balance-title,
.modal-vault .vaulted-title {
    position: absolute;
    top: -7px;
    left: 8px;
    font-size: 10px;
    font-weight: 800;
    z-index: 1;
}
.modal-vault .balance-title { color: #ffce00; }
.modal-vault .vaulted-title { color: #fca80d; }
.modal-vault .balance-inner,
.modal-vault .vaulted-inner {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 13px;
}
.modal-vault .balance-inner {
    background: var(--background2);
    border-radius: 12px;
}
.modal-vault .vaulted-inner {
    background: var(--background1);
    border-radius: 12px;
}
.modal-vault .balance-inner img,
.modal-vault .vaulted-inner img {
    width: 18px;
    height: 18px;
}
.modal-vault .inner-value {
    font-size: 12px;
    font-weight: 600;
    color: #c1c1c1;
}
.modal-vault .inner-value span {
    font-size: 16px;
    font-weight: 800;
    color: #ffffff;
}

/* input */
.modal-vault .vault-amount {
    width: 100%;
    margin-top: 25px;
    position: relative;
}
.modal-vault .vault-amount img {
    width: 18px;
    height: 18px;
    position: absolute;
    top: 50%;
    left: 15px;
    transform: translate(0, -50%);
}
.modal-vault .vault-amount input {
    width: 100%;
    height: 56px;
    padding: 0 20px 0 44px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
    background: var(--background2);
}
.modal-vault .vault-amount input::placeholder {
    color: #5191b1;
}

/* buttons */
.modal-vault button.button-deposit,
.modal-vault button.button-withdraw {
    width: 250px;
    height: 42px;
    margin-top: 30px;
}
.modal-vault button.button-withdraw {
    margin-top: 15px;
    padding: 1px;
}
.modal-vault button.button-deposit .button-inner,
.modal-vault button.button-withdraw .button-inner {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    font-weight: 800;
    color: #ffffff;
}
.modal-vault button.button-deposit .button-inner {
    background: rgb(44, 40, 82);
    color: #fff;
    box-shadow: rgb(35, 32, 66) 0px -3px 0px 0px inset, 
                rgb(89, 81, 142) 0px 2px 0px 0px inset;
    text-shadow: rgb(25, 25, 57) 0px 1px 0px;
    border: 4px solid var(--roo-btn-outline-color, #090C1D);
    border-radius: 12px;
}
.modal-vault button.button-withdraw .button-inner {
    border-radius: 12px;
    background: var(--buttonyellow);
    box-shadow: var(--buttonyellowbox);
    color: #fff;
    text-shadow: -1px -1px 0 #C56A18, 1px -1px 0 #C56A18,
                 -1px 1px 0 #C56A18, 1px 1px 0 #C56A18;
}

/* footer */
.modal-vault .vault-footer {
    width: 100%;
    margin-top: 30px;
    padding-top: 25px;
    border-top: 1px solid #173d5a;
}
.modal-vault .footer-unlocked {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.modal-vault .unlocked-title {
    font-size: 14px;
    font-weight: 800;
    color: #bbbfcf;
}
.modal-vault .unlocked-content {
    width: 100%;
    display: flex;
    margin: 12px;
}
.modal-vault .unlocked-content select {
    width: calc(100% - 62px);
    height: 56px;
    padding: 0 15px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 400;
    color: #bbbfcf;
    background: var(--background2);
    -webkit-appearance: none;
    -moz-appearance: none;
}
.modal-vault button.button-lock {
    width: 56px;
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 6px;
    border-radius: 12px;
    background: rgba(234, 65, 65, 0.25);
    border: 1px solid rgba(234, 65, 65, 0.5);
}
.modal-vault button.button-lock svg { stroke: #ea4141; }
.modal-vault .footer-locked {
    width: 100%;
    height: 58px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background: rgba(234, 65, 65, 0.25);
}
.modal-vault .locked-title {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 700;
    color: #ea4141;
}
.modal-vault .locked-title svg {
    margin-right: 10px;
    stroke: #ea4141;
}
.modal-vault .locked-time {
    margin-top: 2px;
    font-size: 12px;
    font-weight: 400;
    color: #ea4141;
}
.modal-vault .locked-time span { color: #ffffff; }

/* responsive */
@media only screen and (max-width: 620px) {
    .modal-vault {
        width: calc(100vw - 20px);
        padding: 35px 10px 30px 10px;
    }
}
@media only screen and (max-width: 500px) {
    .modal-vault {
        width: 100vw;                  /* tam genişlik */
        max-width: 100%;
        border-radius: 20px 20px 0 0;  /* sadece üst köşeler */
        padding: 65px 15px 30px 15px;  /* sağ-sol denge */
    }
}
@media only screen and (max-width: 400px) {
    .modal-vault .vault-stats {
        flex-direction: column;
    }
    .modal-vault .vault-stats:before,
    .modal-vault .vault-stats:after {
        display: none;
    }
    .modal-vault .stats-balance,
    .modal-vault .stats-vaulted {
        width: 100%;
    }
    .modal-vault .stats-balance {
        margin-bottom: 12px;
        margin-right: 0;
    }
}
</style>
